<template>
  <span
    ref="textRef"
    v-tooltip.placementRight="tooltip"
    class="tw-block tw-truncate tw-min-w-0"
  >
    {{ text }}
  </span>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import useDynamicTooltip from '@app/shared/vue/composables/use-dynamic-tooltip'

defineOptions({ name: 'SfTruncatedLabel' })

interface Props {
  text: string
}

const props = defineProps<Props>()

const textRef = ref<HTMLElement | null>(null)
// A getter, not the plain value: the composable re-checks truncation and
// refreshes the tooltip when the text changes after mount.
const tooltip = useDynamicTooltip(textRef, () => props.text)
</script>
